import validate from 'validate';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import { MAP_LIST } from '$http';


export default {
    data() {
        return {
            contactInfo: this.refGetContactInfo(),
            valid: false
        };
    },
    props:{
        isReadOnly: {
            default: false
        },
        myIndex: {
            default: 1
        },
        hasDelFn: {
            default: true
        },
        value: {
            type: Object,
            default: null
        }
    },
    computed: {
        getIndex() {
            return '联系人-' + this.myIndex;
        },
        hasDelBtnShow() {
            if (this.isReadOnly) {
                return false;
            }
            if (!this.hasDelFn) {
                return false;
            }
            return true;
        }
    },
    created() {
        if (isCorrectVal(this.value)) {
            this.setValue();
            return;
        }
        this.contactInfo = this.refGetContactInfo();
    },
    watch: {
        value: {
            deep: true,
            handler: function(val) {
                this.setValue();
            }
        }
    },
    methods: {
        refGetContactInfo() {
            return cloneDeep({
                C_name: "", 
                C_tel:"",
                C_email: "",
                C_QQ: "",
                C_weixin: "",
                C_position:""
                
            });
        },
        clearData() {
            this.contactInfo = (this.refGetContactInfo());
        },
        resetFields() {
            this.$refs.form.resetFields();
            this.clearData();
        },
        deletefn(index) {
            this.$emit('delContactfn', {
                index: index
            });
        },
        setValue() {
            this.$nextTick(() => {
                let contactInfo = cloneDeep(this.value);
                this.contactInfo = $.extend({}, this.refGetContactInfo(), util.filterAndSetData(this.refGetContactInfo(), contactInfo));
                this.isSetData = true;
            });

        },
        validate() {

           
            let rules = [];

            rules.push({
                name: "联系人姓名",
                value: this.contactInfo.C_name,
                required: true 
            });

            rules.push({
                name: "联系人电话",
                value: this.contactInfo.C_tel,
                phone: true
            });

            let flag = util.checkForm({
                ele: this,
                rules: rules
            });
            
            if (flag) {
                return this.contactInfo;
            }
            return false;
        },
    },
    mounted() {
        
    }
};


// WEBPACK FOOTER //
// ./src/common/components/link-info/vm.js